// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"372":"3082514e","466":"ac961fa8","738":"6fe02713","856":"945b9e1b"}[chunkId] + ".chunk.js";
};